"use client";

import { useRouter } from "next/navigation";
import { type ChangeEventHandler } from "react";

import { DEFAULT_SEARCH_ENTRIES_PER_PAGE, SEARCH_PARAMS } from "@/globals";
import { messages } from "@/globals.content";
import { progressSingleton } from "@/singletons/progress.singleton";

const ENTRIES_PER_PAGE_OPTIONS = [DEFAULT_SEARCH_ENTRIES_PER_PAGE, 18, 27, 54];

type SearchModuleEntriesProps = {
    baseURL: string;
    currentSearchString: string;
    entryId?: string;
};
export const SearchModuleEntriesView = ({
    currentSearchString,
    entryId,
    baseURL,
}: SearchModuleEntriesProps) => {
    const router = useRouter();

    const urlSearchParams = new URLSearchParams(currentSearchString);

    const handleChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
        progressSingleton.createProgress().run(200).finish(6000);
        urlSearchParams.set(SEARCH_PARAMS.entries, e.currentTarget.value);

        urlSearchParams.delete(SEARCH_PARAMS.page);

        router.push(`${baseURL}?${urlSearchParams.toString()}${entryId ? "#" + entryId : ""}`);
    };

    return (
        <select
            onChange={handleChange}
            value={urlSearchParams.get(SEARCH_PARAMS.entries) ?? undefined}
            className="entriesPerPage"
        >
            {ENTRIES_PER_PAGE_OPTIONS.map((option) => (
                <option value={option} key={option}>
                    {option} {messages.pagination.entries}
                </option>
            ))}
        </select>
    );
};
